import { render, staticRenderFns } from "./right-silder.vue?vue&type=template&id=6938747a&scoped=true&"
import script from "./right-silder.vue?vue&type=script&lang=js&"
export * from "./right-silder.vue?vue&type=script&lang=js&"
import style0 from "./right-silder.vue?vue&type=style&index=0&id=6938747a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6938747a",
  null
  
)

export default component.exports